import GetUserByIdRequestModelBase from '../_generated/modelBases/get-user-by-id-request-model-base';

export default class GetUserByIdRequestModel extends GetUserByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
